import React from 'react';
import { FormattedMessage } from 'react-intl';
import { RadioGroupItemWrapper } from '../../pages/SchedulingPage/components/styles';

export default function ReasonForVisitOption({ name, selected }) {
  return (
    <RadioGroupItemWrapper selected={selected}>
      <FormattedMessage
        id="scheduling.ReasonForVisitOption.reasonForvisitOption"
        defaultMessage={name}
      />
    </RadioGroupItemWrapper>
  );
}
